module.exports = __webpack_public_path__ + "static/media/image_95.5baa4916.png";